var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5C18.3852 14.5002 18.7556 14.6486 19.0344 14.9144C19.3132 15.1802 19.479 15.5431 19.4975 15.9279C19.516 16.3127 19.3858 16.6898 19.1338 16.9812C18.8818 17.2726 18.5274 17.4558 18.144 17.493L18 17.5H2C1.61478 17.4998 1.24441 17.3514 0.965613 17.0856C0.686821 16.8198 0.520988 16.4569 0.502476 16.0721C0.483964 15.6873 0.614192 15.3102 0.866175 15.0188C1.11816 14.7274 1.47258 14.5442 1.856 14.507L2 14.5H18ZM18 7.5C18.3978 7.5 18.7794 7.65804 19.0607 7.93934C19.342 8.22064 19.5 8.60218 19.5 9C19.5 9.39782 19.342 9.77936 19.0607 10.0607C18.7794 10.342 18.3978 10.5 18 10.5H2C1.60218 10.5 1.22064 10.342 0.93934 10.0607C0.658035 9.77936 0.5 9.39782 0.5 9C0.5 8.60218 0.658035 8.22064 0.93934 7.93934C1.22064 7.65804 1.60218 7.5 2 7.5H18ZM18 0.5C18.3978 0.5 18.7794 0.658035 19.0607 0.93934C19.342 1.22064 19.5 1.60218 19.5 2C19.5 2.39782 19.342 2.77936 19.0607 3.06066C18.7794 3.34196 18.3978 3.5 18 3.5H2C1.60218 3.5 1.22064 3.34196 0.93934 3.06066C0.658035 2.77936 0.5 2.39782 0.5 2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5H18Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.09e70ebeed01d4af8d14aee925549573.svg";
export { ForwardRef as ReactComponent };